<template>
  <m-card310 class="store-card-310" v-if="store.role === 2" :image-link="{name:'SingleStore',params:{store:store.name}}"
             :image="store.image" :alt="store.name">
    {{ $t('multiple_store.card.store_name', {store: store.name}) }}
  </m-card310>
</template>

<script>
import mCard310 from "../../Cards/Card310";

export default {
  name: "StoreCard310",
  components: {mCard310},
  props: {
    store: {}
  },
}
</script>

<style scoped>

</style>